import React from "react";
import { ExternalLink, List } from "lucide-react";

const fmt = (t) => t
  .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
  .replace(/\*(.*?)\*/g, "<b>$1</b>")
  .replace(/(^|\s)_(.+?)_(?=\s|$)/g, "$1<i>$2</i>")
  .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" rel="noreferrer" class="text-[#027EB5] underline break-all">$1</a>');

const time = (iso) => (iso ? new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "");

const Extras = ({ m }) => (
  <>
    {m.buttons?.length > 0 && (
      <div className="mt-2 -mx-1 flex flex-col gap-1">
        {m.buttons.map((b) => <div key={b} className="text-center text-[13px] font-semibold text-[#027EB5] bg-[#F7FBFD] border border-[#027EB5]/15 rounded-md py-1.5">{b}</div>)}
      </div>
    )}
    {m.rows?.length > 0 && (
      <div className="mt-2 border-t border-gray-100 pt-1.5">
        <div className="text-center text-[13px] font-semibold text-[#027EB5] flex items-center justify-center gap-1"><List className="h-3.5 w-3.5" /> {m.list_button}</div>
        <ul className="mt-1 space-y-0.5">{m.rows.map((r) => <li key={r.id} className="text-xs text-gray-600">• {r.title}{r.description ? <span className="text-gray-400"> — {r.description}</span> : null}</li>)}</ul>
      </div>
    )}
    {m.link && (
      <div title={m.link.url} className="mt-2 flex items-center justify-center gap-1 text-[13px] font-semibold text-[#027EB5] border-t border-gray-100 pt-1.5 cursor-default">
        <ExternalLink className="h-3.5 w-3.5" /> {m.link.label}
      </div>
    )}
  </>
);

export const ChatBubble = ({ m, testid }) => (
  <div data-testid={testid} className={`flex ${m.from === "user" ? "justify-end" : "justify-start"}`}>
    <div className={`max-w-[85%] rounded-lg px-3 py-2 text-sm shadow-sm ${m.from === "user" ? "bg-[#DCF8C6] rounded-tr-none" : "bg-white rounded-tl-none"}`}>
      <div className={`text-[10px] font-bold uppercase tracking-wider mb-0.5 ${m.channel === "whatsapp" ? "text-[#075E54]" : "text-[#8B0000]"}`}>{m.channel === "whatsapp" ? "WhatsApp" : "Web agent"}</div>
      <div className="whitespace-pre-line text-gray-800 break-words" dangerouslySetInnerHTML={{ __html: fmt(m.text || "") }} />
      <Extras m={m} />
      <div className="text-[10px] text-gray-400 text-right mt-1">{time(m.at)}</div>
    </div>
  </div>
);
